import React from "react";
import { NavDropdown } from "react-bootstrap";
import BoomLogoIcon from "../../assets/logo_boomlogic.svg2";
import {
  useChangeProductMutation,
  useGetAccountSettingsDataQuery,
  useGetUsersAccountsQuery,
} from "../store/slices/settingsSlice";
import { toast } from "react-toastify";

export default function AppSwitcher() {
  const { data: accounts } = useGetUsersAccountsQuery();
  const { data: currentAccount } = useGetAccountSettingsDataQuery();
  const [changeProduct] = useChangeProductMutation();

  return (
    <NavDropdown
      title={<BoomLogoIcon width={125} />}
      id="app-switcher-dropdown"
      className="py-3 px-5 ms-4 me-auto bg-page bg-accross align-self-stretch text-white"
      style={{ "--bs-body-bg": "var(--color-navy)" } as any}
    >
      {accounts
        ?.filter((account: any) => account.accessible)
        ?.map((account: any) => (
          <NavDropdown.Item
            key={account.id}
            href={`/changeproduct/${account.id}`}
            className={`text-white${
              currentAccount?.client_id === account.id ? " active" : ""
            }`}
            onClick={async (e) => {
              e.preventDefault();
              const res = await changeProduct({ accountId: account.id });
              if ("error" in res) {
                const err = res.error;
                // Build a safe error message by narrowing the union
                if (
                  "data" in err &&
                  err.data &&
                  typeof err.data === "object" &&
                  "message" in (err.data as any)
                ) {
                  toast.error(
                    `Failed to change product: ${(err.data as any).message}`
                  );
                } else if (
                  "message" in err &&
                  typeof err.message === "string"
                ) {
                  toast.error(`Failed to change product: ${err.message}`);
                } else {
                  toast.error("Failed to change product");
                }
                return;
              }
              window.location.href = "/";
            }}
          >
            {account.product_name} ({account.product_type})
          </NavDropdown.Item>
        ))}
    </NavDropdown>
  );
}
